<div>
<div>
<div>
<div>
<div class="panel panel-table">
<div class="panel-heading">
<h3 class="panel-title"><strong>DATA INTEGRATION TOOLKIT WEBSITE</strong></h3>
</div>
<div class="d-flex panel-body fixed-panel">
<div class="col-sm" style="float:left">

<p><i>Este site foi desenhado para permitir-lhe explorar o Data Integration Toolkit e compreender um conjunto alargado de potencialidades.</i></p>
<strong>Acesso a Dados D&B em Tempo Real</strong>
<p>O Data Integration Toolkit™ (Toolkit) é um interface desenhado para permitir o acesso a dados globais da D&B, em tempo real. O Toolkit retira a complexidade da interacção de dados entre os sistemas e aplicações e oferece a maneira mais flexível e rentável de aceder e integrar os dados globais da D&B, nas aplicações do seu negócio. Com o Data Integration Toolkit terá acesso a mais de 100 milhões de registos de empresas, conduzidos por patentes e propriedades D&B - <a aria-label="Link to Dnb info quality" target="_blank" href="http://www.dnb.com/us/about/db_database/dnbinfoquality.html">DUNSRight®</a>, permitindo-lhe desta forma aumentar a rapidez e exactidão na tomada de decisões da sua empresa.</p>
<p>O Data Integration Toolkit é fácil de instalar e integrar, oferecendo:</p>
<ul>
<li>Dados Globais D&B em tempo real</li>
<li>Tecnologia de entrega baseada em XML</li>
<li>Documentação Online, serviço e apoio profissional</li>
<li>Soluções Pré-Integradas compatíveis com fornecedores lideres em ERP, CRM e e-Commerce incluindo Oracle e SAP</li>
</ul>
<strong>Perícia Global na Gestão de Dados</strong>
<p>O Data Integration Toolkit fornece-lhe também a solução para um dos aspectos mais complicados na integração de dados - a possibilidade de obter dados consistentes de todas as partes do mundo, minimizando diferenças locais e regionais, utilizando apenas uma única plataforma. Traduza e partilhe informação na língua da sua escolha, poupando nos custos de gerir múltiplas fontes de informação. Desta forma, poderá melhorar a exactidão e eficiência dos seus processos de tomada de decisão sempre que estiver a fazer negócios.</p>
<p>Como o Data Integration Toolkit não é necessário alterar o seu modelo de negócio. Irá apenas tomar melhores decisões porque terá acesso, em tempo real, a informações para ajudá-lo a decidir com confiança.</p>
<p>Clique em <a aria-label="Solutions" [routerLink]="'/unlocked/solutions-home-po'">Soluções</a> para obter informação detalhada sobre o Data Integration Toolkit. Se já é cliente clique em <a aria-label="Link to Tecnologia" [routerLink]="'/unlocked/technology-po'">Tecnologia</a> para efectuar o download de API, documentação técnica e informação sobre os formatos dos dados. Para informação sobre disponibilidade do serviço e informação técnica clique em <a aria-label="Link to Suporte" [routerLink]="'/unlocked/support-po'">Suporte.</a></p>
<br>
<p><a aria-label="Top" tabindex=0 role=link (click)="Top()">top</a></p>


</div>
<right-box></right-box>
</div>
</div>
</div>
</div>
</div>
</div>